import { render, staticRenderFns } from "./ModalAntiFraud.vue?vue&type=template&id=84aea280&scoped=true"
import script from "./ModalAntiFraud.vue?vue&type=script&lang=js"
export * from "./ModalAntiFraud.vue?vue&type=script&lang=js"
import style0 from "./ModalAntiFraud.vue?vue&type=style&index=0&id=84aea280&prod&scoped=true&lang=css"
import style1 from "./ModalAntiFraud.vue?vue&type=style&index=1&id=84aea280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aea280",
  null
  
)

export default component.exports